import React, { useEffect, useState } from "react";
import Modal from "react-modal";
import { QualityAlertDiscrepantMaterial } from "../../../models/quality-alert";

Modal.setAppElement("#root"); // Ensure the modal is accessible for screen readers

interface ModalProps {
  isOpen: boolean;
  onRequestClose: () => void;
  onSave: (
    quantity: number,
    responsibility: string,
    dispositionValue: string,
  ) => void;
  partNumber: string;
  discrepantMaterial?: QualityAlertDiscrepantMaterial;
}

const CustomModal: React.FC<ModalProps> = ({
  isOpen,
  onRequestClose,
  onSave,
  partNumber,
  discrepantMaterial,
}) => {
  const [quantity, setQuantity] = useState<number>(
    discrepantMaterial?.qty || 0,
  );
  const [responsibility, setResponsibility] = useState<string>(
    discrepantMaterial?.responsibility || "OEM Manufacturer",
  );
  const [disposition, setDisposition] = useState<string>(
    discrepantMaterial?.disposition || "",
  );

  const handleSave = () => {
    onSave(quantity, responsibility, disposition);
    onRequestClose();
  };

  const handleReset = () => {
    setQuantity(0);
    setResponsibility("OEM Manufacturer");
    setDisposition("");
  };

  return (
    <Modal
      isOpen={isOpen}
      onRequestClose={onRequestClose}
      className="relative w-96 rounded bg-white p-6 shadow-md"
      overlayClassName="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center"
    >
      {/* Close Button */}
      <button
        className="absolute right-2 top-2 text-gray-500 hover:text-gray-800"
        onClick={onRequestClose}
      >
        &times;
      </button>

      <h2 className="mb-4 text-lg font-bold text-black">
        Discrepant Material ({partNumber})
      </h2>

      {/* Quantity Input */}
      <div className="mb-4">
        <label className="mb-2 block text-sm font-medium text-black">
          Quantity
        </label>
        <input
          type="number"
          value={quantity}
          onChange={(e) => setQuantity(Number(e.target.value))}
          className="w-full rounded border border-gray-300 bg-white px-3 py-2 text-black"
          min="0"
        />
      </div>

      {/* Responsibility Dropdown */}
      <div className="mb-4">
        <label className="mb-2 block text-sm font-medium text-black">
          Responsibility
        </label>
        <select
          value={responsibility}
          onChange={(e) => setResponsibility(e.target.value)}
          className="w-full rounded border border-gray-300 bg-white px-3 py-2 text-black"
        >
          <option value="OEM Manufacturer">OEM Manufacturer</option>
          <option value="Supplier">Supplier</option>
        </select>
      </div>

      {/* Other Select Dropdown */}
      <div className="mb-4">
        <label className="mb-2 block text-sm font-medium text-black">
          Disposition
        </label>
        <select
          value={disposition}
          onChange={(e) => setDisposition(e.target.value)}
          className="w-full rounded border border-gray-300 bg-white px-3 py-2 text-black"
        >
          <option value="">Select an option</option>
          <option value="Scrapped">Scrapped</option>
          <option value="Held">Held</option>
          <option value="Returned">Returned</option>
          <option value="Reworked">Reworked</option>
          <option value="Installed in vehicle">Installed in vehicle</option>
        </select>
      </div>

      {/* Save Button */}
      <div className="text-right">
        <button
          className="rounded bg-blue-500 px-4 py-2 text-white hover:bg-blue-600"
          onClick={handleSave}
        >
          Save
        </button>
      </div>
    </Modal>
  );
};

export default CustomModal;
